import React, { Fragment, useCallback } from 'react';
import { useSelector } from 'react-redux';
import i18n from '../../../../i18n';
import { Box } from '@material-ui/core';

import { useAction } from 'core/store/store';

import { makeSubscriptionChangeAction } from 'state/subscription/actions';
import { subscriptionCurrentSelector, subscriptionPaymentMethodSelector } from 'state/subscription/selectors';

import { LargeButton, LargeButtonColor } from 'components/LargeButton/LargeButton';
import { Text, TextTypography } from 'components/Text/Text';
import { MaskedCard } from 'components/MaskedCard/MaskedCard';

export const VendorSubscriptionActive = () => {
    const { t } = i18n.useTranslation();
    const action = useAction();
    const currentSubscription = useSelector(subscriptionCurrentSelector);
    const paymentMethod = useSelector(subscriptionPaymentMethodSelector);
    const onChange = useCallback(() => {
        action(makeSubscriptionChangeAction);
    }, []);

    return (
        <Fragment>
            {currentSubscription && (
                <Fragment>
                    <Box m={3}>
                        <Text typography={TextTypography.PARA}>{t('vendor:userMenu.subscription.card')}:&nbsp;</Text>
                        <Text typography={TextTypography.PARA_ACCENT}>
                            <span>{paymentMethod.cardType}</span>&nbsp;
                            <span>
                                <MaskedCard lastDigits={paymentMethod.cardLast4} />
                            </span>
                        </Text>
                    </Box>
                    <Box m={3}>
                        <LargeButton color={LargeButtonColor.LIGHT} onClick={onChange}>
                            {t('vendor:userMenu.subscription.changeButton')}
                        </LargeButton>
                    </Box>
                    {/*<Box m={2}>*/}
                    {/*    <LargeButton color={LargeButtonColor.ERROR} onClick={onPause}>*/}
                    {/*        {t('vendor:userMenu.subscription.cancelButton')}*/}
                    {/*    </LargeButton>*/}
                    {/*</Box>*/}
                    {/*<Box m={2}>*/}
                    {/*    <Text typography={TextTypography.CAPTION}>*/}
                    {/*        {t('vendor:userMenu.subscription.activeSubscriptionFooter', {*/}
                    {/*            date: formatISOShortDate(currentSubscription.renewalDate),*/}
                    {/*        })}*/}
                    {/*    </Text>*/}
                    {/*</Box>*/}
                </Fragment>
            )}
        </Fragment>
    );
};
